import {
  GET_BUSINESS_SUCCESS,
  ADD_BUSINESS_SUCCESS,
  UPDATE_BUSINESS_ACCESS_SUCCESS,
  GET_APP_SETTINGS_SUCCESS,
} from "./constants"

const initialState = {
  business: [],
  appSettings: {},
}

function adminConsoleReducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_BUSINESS_SUCCESS:
      return {
        ...state,
        business: payload,
      }
    case GET_APP_SETTINGS_SUCCESS:
      return {
        ...state,
        appSettings: payload?.docs,
      }
    default:
      return state
  }
}

export default adminConsoleReducer
